import React from 'react';
import styled from 'styled-components';
import { Modal } from 'merchant-portal-components';
import { ButtonRow, Button, LoadingButton } from 'merchant-portal-components';
import { ModalBody } from '../../../../../../components/FormElements/FormElements.js';

const Title = styled.p`
  width: 500px;
  height: 24px;
  flex-grow: 0;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  text-align: left;
  padding-left: 36px;
  font-family: Montserrat;
  color: #191818;
`;

const BodyContent = styled.div`
  width: 502px;
  height: 100px;
  flex-grow: 0;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: 0.25px;
  text-align: left;
  padding-left: 36px;
  font-family: Montserrat;
  color: #191818;
`;

const StyledModal = styled(Modal)`
  width: 550px;
  height: 387px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 24px;
  padding: 24px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
`;

function LocationReactivationModal({
  location,
  businessId,
  requestingDeactivation,
  cancel,
  updateBusinessInformation,
}) {
  return (
    <StyledModal>
      <ModalBody medium>
        <Title>Active {location?.name}?</Title>
        <BodyContent>
          Activating will make this location visible and available to accept
          orders on mobile and/or web apps immediately. If the location is not
          ready to accept orders turn off Order Ahead in the Business
          Information section of this page.
        </BodyContent>
        <ButtonRow justifyContent='space-between' marginLeft={0}>
          <Button
            small
            type='button'
            secondary
            onClick={(e) => {
              cancel && cancel();
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            Cancel
          </Button>
          {requestingDeactivation ? (
            <LoadingButton whiteSpinner small type='button' danger>
              Yes, Activate
            </LoadingButton>
          ) : (
            <Button
              small
              type='button'
              onClick={(e) => {
                updateBusinessInformation(
                  {
                    ...location,
                    master_is_active: true,
                  },
                  businessId,
                  location
                );
                localStorage.removeItem(
                  `location-${location.name}-deactivation-time`
                );
                cancel && cancel();
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              Yes, Activate
            </Button>
          )}
        </ButtonRow>
      </ModalBody>
    </StyledModal>
  );
}

export default LocationReactivationModal;
